import React, { useState, useRef, useEffect } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import MenuBar from "./MenuBar";
import store from "../../store";
import { orderListValue } from "../../store/slices/order";
import useHttp from "../../hooks/useHttp";
import shortid from "shortid";
import Avatar from "@mui/material/Avatar";

import "../../assets/css/utility/home_page_header.css";
import "../../assets/css/profile.page.css";
import PDLogo from "../../assets/media/logo/pd_logo_(orange).png";
import avatar from "../../assets/media/avatar.png";
import {
  fetchBasicInfo,
  updateLatestChatRoomsList,
} from "../../store/slices/basicInfo";
import {
  NOTIFICATION_GET_URL,
  TOTAL_UNREAD_NOTIFICATION_NUMBER_URL,
  ORDERS_GET_URL,
  USER_DETAILS_URL,
} from "../../utils/api-ends";
import {
  disConnectNotificationSocket,
  connectNotificationSocket,
  notificationNumValue,
  notificationListValue,
  appendNotification,
} from "../../store/slices/notification";
import connectSocket from "../../services/socket/connection";
import { Modal } from "@mui/material";

const accessToken = JSON.parse(localStorage.getItem("auth_token"))?.access;

const LoggedInUserHeader = () => {
  const clint_width = window.innerWidth;

  const [profile_menu, setProfile_menu] = useState(false);
  const userData = useSelector((state) => state.basicInfo);
  const loadPostNav = useRef();
  const messageNav = useRef();
  const notificationNav = useRef();
  const dispatch = useDispatch();
  const { sendRequests } = useHttp();
  const notificationData = useSelector((state) => state.notification);
  const orderData = useSelector((state) => state.order);
  const latestChatRooms = useSelector(
    (state) => state.basicInfo.latestChatRooms
  );
  const notificationSocket = useSelector((state) => state.notification.socket);
  const isSocketConnected = useSelector(
    (state) => state.notification.isConnected
  );
  const [openLogoutModal, setOpenLogoutModal] = useState(false);

  const running_order_list = useSelector((state) => state.order?.orderList);

  let { pathname } = useLocation();
  let navigate = useNavigate();

  const open_sub_nav = (e) => {
    !profile_menu && e.current.setAttribute("has-subnav", "true");
  };

  const close_sub_nav = (e) => {
    !profile_menu && e.current.setAttribute("has-subnav", "false");
  };

  const open_profile_menu = (e) => {
    const header_ = document.getElementsByTagName("header")[0];
    if (!profile_menu) {
      header_.setAttribute("profile-menu", "open");
      setProfile_menu(true);
    } else {
      header_.setAttribute("profile-menu", "close");
      setProfile_menu(false);
    }
  };

  const close_mobile_nav = () => {
    if (clint_width > 999) return false;

    document.getElementById("menu-bar").setAttribute("menu", "close");
    document.getElementsByTagName("body")[0].setAttribute("menu", "close");
    document
      .getElementsByTagName("header")[0]
      .setAttribute("profile-menu", "close");
  };

  const handleLogout = (e) => {
    // Assign user info to store
    dispatch(
      fetchBasicInfo({
        isAuthenticated: false,
      })
    );

    // Disconnect notification socket
    dispatch(disConnectNotificationSocket());

    localStorage.removeItem("auth_token");
    handleClose();

    window.location.href = `/`;
  };

  const handleClose = () => {
    setOpenLogoutModal(false);
  };

  document.addEventListener("click", function (e) {
    const header = document.getElementsByTagName("header")[0];
    const user_header_usefull_link = document.getElementById("user-header-nav");
    const user_header_profile_img = document.getElementById("user-header-img");

    if (
      user_header_usefull_link !== null &&
      !user_header_usefull_link.contains(e.target) &&
      !user_header_profile_img.contains(e.target)
    ) {
      header.setAttribute("profile-menu", "close");
      setProfile_menu(false);
    }
  });

  const mobileUiNavigate = (e) => {
    var viewport_width =
      window.innerWidth || document.documentElement.clientWidth;
    viewport_width < 1000 && navigate(`/${e}`);
  };

  useEffect(() => {
    const response = (data) => {
      store.dispatch(
        notificationListValue({
          notificationValue: data.results,
        })
      );
    };
    // Send request to get Notification list
    sendRequests(
      {
        url: NOTIFICATION_GET_URL(1),
        method: "GET",
      },
      response
    );
  }, []);

  useEffect(() => {
    const response = (data) => {
      store.dispatch(
        notificationNumValue({
          notificationNum: data.unread_notification_num,
        })
      );
    };
    // Send request to get total unread notification number
    sendRequests(
      {
        url: TOTAL_UNREAD_NOTIFICATION_NUMBER_URL,
        method: "GET",
      },
      response
    );
  }, []);

  useEffect(() => {
    const response = (data) => {
      store.dispatch(
        orderListValue({
          orderValue: data.results,
        })
      );
    };
    // Send request to get Order list
    sendRequests(
      {
        url: ORDERS_GET_URL("", 1),
        method: "GET",
      },
      response
    );
  }, []);

  const isAuthenticated = useSelector(
    (state) => state.basicInfo?.isAuthenticated
  );

  useEffect(() => {
    const response = (data) => {
      store.dispatch(
        fetchBasicInfo({
          isAuthenticated: true,
          userInfo: data?.data?.user_info,
          latestChatRooms: data?.data?.chat_rooms_info,
        })
      );
    };
    sendRequests(
      {
        url: USER_DETAILS_URL,
        method: "GET",
      },
      response
    );
  }, [isAuthenticated]);

  // Connect notification socket
  useEffect(() => {
    if (!isSocketConnected && isAuthenticated) {
      dispatch(
        connectSocket(
          `/notification/?authorization=${accessToken}`,
          connectNotificationSocket,
          disConnectNotificationSocket
        )
      );
    }
  }, [isSocketConnected, isAuthenticated]);

  // Notification group messages
  useEffect(() => {
    if (notificationSocket) {
      notificationSocket.onmessage = (event) => {
        const data = JSON.parse(event.data);

        if (data.response_type === "latest_msg_notification") {
          dispatch(
            updateLatestChatRoomsList({
              unread_message_count: data?.unread_message_count,
              chat_room_info: data.chat_room_info,
            })
          );
        }

        if (data?.notification_data) {
          dispatch(
            appendNotification({
              notification: data.notification_data,
            })
          );
        }

        if (data.unread_notification_count) {
          dispatch(
            notificationNumValue({
              notificationNum: data.unread_notification_count,
            })
          );
        }
      };

      notificationSocket.onclose = (event) => {
        // Reconnect notification socket when disconnect
        setTimeout(() => {
          dispatch(
            connectSocket(
              `/notification/?authorization=${accessToken}`,
              connectNotificationSocket,
              disConnectNotificationSocket
            )
          );
        }, 5000);
      };
    }
  }, [notificationSocket]);

  return (
    <>
    <header className="user-header-logged" profile-menu="close">
      <div className="container">
        <div className="header-navigations">
          <a href="/profile-information/" id="logo">
            <div>
              <img width="80" src={PDLogo} alt="img" />
            </div>
          </a>

          <div className="nav-bar">
            {userData.isAuthenticated}
            {userData?.isAuthenticated && (
              <div className="user-userfull-link-and-info" id="user-header-nav">
                <div>
                  <span className="total-balance">
                    Total Balance : {userData.userDetails?.balance} $
                  </span>

                  <NavLink
                    to={"/profile-information/"}
                    className={({ isActive }) =>
                      isActive ? "activeNav" : undefined
                    }
                    onClick={() => {
                      open_profile_menu();
                      close_mobile_nav();
                    }}
                  >
                    <i className="fa-solid fa-user"></i> Profile
                  </NavLink>
                  <NavLink
                    to={"/account-information/"}
                    className={({ isActive }) =>
                      isActive ? "activeNav" : undefined
                    }
                    onClick={() => {
                      open_profile_menu();
                      close_mobile_nav();
                    }}
                  >
                    <i className="fa-regular fa-address-card"></i> Account Details
                  </NavLink>

                  <Link
                    to="/update-profile/profile-information"
                    className={
                      pathname?.split("/").includes("update-profile")
                        ? "activeNav"
                        : undefined
                    }
                    onClick={() => {
                      open_profile_menu();
                      close_mobile_nav();
                    }}
                  >
                    <i className="fa-solid fa-gear"></i> Settings
                  </Link>
                  <button onClick={() => setOpenLogoutModal(true)}>
                    {" "}
                    <i className="fa-solid fa-arrow-right-from-bracket"></i> Log
                    Out
                  </button>
                </div>
              </div>
            )}

            {userData?.userDetails?.user_type === "shipper" && (
              <div
                onMouseOver={() => {
                  open_sub_nav(loadPostNav);
                }}
                onMouseLeave={() => {
                  close_sub_nav(loadPostNav);
                }}
                ref={loadPostNav}
                has-subnav="false"
              >
                <button
                  className={
                    pathname?.split("/").includes("load-post")
                      ? "activeNav"
                      : undefined
                  }
                >
                  Post Load <i className="fa-solid fa-angle-right"></i>
                </button>

                <div className="header-sub-navbar resp-header-sub-navbar">
                  <NavLink
                    to="/load-post/create"
                    onClick={close_mobile_nav}
                    className={({ isActive }) =>
                      isActive ? "activeNav" : undefined
                    }
                  >
                    Create New Load
                  </NavLink>
                  <NavLink
                    to="/load-post/shipper-loadpost"
                    onClick={close_mobile_nav}
                    className={({ isActive }) =>
                      isActive ? "activeNav" : undefined
                    }
                  >
                    All Loads
                  </NavLink>
                </div>
              </div>
            )}

            {userData?.userDetails?.user_type === "carrier" && (
              <>
                <NavLink
                  to="/search-load-post"
                  className={({ isActive }) =>
                    isActive ? "activeNav" : undefined
                  }
                  onClick={close_mobile_nav}
                >
                  Search
                </NavLink>
                <NavLink
                  to="/carrier/offer-list"
                  className={({ isActive }) =>
                    isActive ? "activeNav" : undefined
                  }
                  onClick={close_mobile_nav}
                >
                  Offers
                </NavLink>
                <NavLink
                  to="/pending-offers/"
                  className={({ isActive }) =>
                    isActive ? "activeNav" : undefined
                  }
                  onClick={close_mobile_nav}
                >
                  Monitor
                </NavLink>
              </>
            )}

            <NavLink
                to="/order/order-list"
                className={({ isActive }) =>
                  isActive ? "activeNav" : undefined
                }
                onClick={close_mobile_nav}
              >
                Track
              </NavLink>

            
            <Link
              to="/chat"
              onClick={close_mobile_nav}
              className={
                pathname?.split("/").includes("chat")
                  ? "rspv-nav-bar activeNav"
                  : "rspv-nav-bar"
              }
            >
              Messages ({latestChatRooms?.unread_message_count})
            </Link>
            {userData?.userDetails?.user_type === "carrier" &&
              running_order_list &&
              running_order_list.length > 0 && (
                <NavLink
                  to="/carrier/order-navigations"
                  className={({ isActive }) =>
                    isActive ? "activeNav" : undefined
                  }
                  onClick={close_mobile_nav}
                >
                  Running Orders
                </NavLink>
              )}

            {userData?.userDetails?.user_type === "carrier" && (
              <NavLink
                to="/performance/"
                className={({ isActive }) =>
                  isActive ? "activeNav" : undefined
                }
                onClick={close_mobile_nav}
              >
                Performance
              </NavLink>
            )}
            <NavLink
              to="/transaction"
              className={({ isActive }) => (isActive ? "activeNav" : undefined)}
              onClick={close_mobile_nav}
            >
              Transactions
            </NavLink>
            {userData?.userDetails?.user_type === "shipper" ? (
              <NavLink
                to="/favorite/"
                className={({ isActive }) =>
                  isActive ? "activeNav" : undefined
                }
                onClick={close_mobile_nav}
              >
                Favorite Carriers
              </NavLink>
            ) : (
              ""
            )}
            {userData?.userDetails?.user_type === "shipper" && (
              <NavLink
                to="/search-carrier"
                className={({ isActive }) =>
                  isActive ? "activeNav" : undefined
                }
                onClick={close_mobile_nav}
              >
                Search Carrier
              </NavLink>
            )}


            <NavLink
              to="/wallet/"
              className={({ isActive }) => (isActive ? "activeNav" : undefined)}
              onClick={close_mobile_nav}
            >
              Wallet
            </NavLink>
            <button className="rspv-nav-bar" onClick={() => setOpenLogoutModal(true)}>
              Log Out
            </button>
          </div>

          <div className="right-side-nav-bar">
            <div
              onMouseOver={() => {
                open_sub_nav(messageNav);
              }}
              onMouseLeave={() => {
                close_sub_nav(messageNav);
              }}
              ref={messageNav}
              has-subnav="false"
            >
              <button onClick={() => mobileUiNavigate("chat")}>
                <i className="fa-brands fa-facebook-messenger"></i>
                <span>{latestChatRooms?.unread_message_count}</span>
              </button>

              <div className="header-sub-navbar">
                <div className="header-messenger-notification">
                  {latestChatRooms?.latest_chat_rooms?.map((item) => (
                    <Link
                      className="d-block"
                      key={item.id}
                      to={`/chat/${item.channel_id}`}
                    >
                      <div className="row">
                        <div className="col-2 p-0">
                          <Avatar
                            className="userImg"
                            alt="Remy Sharp"
                            src={item?.partner_info?.profile_image}
                          />
                        </div>
                        <div className="col-7">
                          <p>{item?.partner_info?.full_name}</p>
                          <p>
                            {item?.last_msg_send_by === "me"
                              ? "You"
                              : item?.partner_info?.full_name}{" "}
                            {": "}
                            {item?.last_msg_content}
                          </p>
                        </div>
                        <div className="col-3">
                          <span>{item?.last_msg_timesince}</span>
                        </div>
                      </div>
                    </Link>
                  ))}

                  <div className="multiple-btn">
                    <Link to="/chat"> See All Messages </Link>
                  </div>
                </div>
              </div>
            </div>

            <div
              onMouseOver={() => {
                open_sub_nav(notificationNav);
              }}
              onMouseLeave={() => {
                close_sub_nav(notificationNav);
              }}
              ref={notificationNav}
              has-subnav="false"
            >
              <button onClick={() => mobileUiNavigate("notification")}>
                <i className="fa-solid fa-bell"></i>
                <span>{notificationData.notificationNum}</span>
              </button>
              <div className="header-sub-navbar">
                <div className="header-messenger-notification">
                  {notificationData.notificationList?.length > 0 ? (
                    notificationData.notificationList
                      .slice(0, 5)
                      ?.map((value, index) => (
                        <Link
                          to={
                            value?.notification_link
                              ? value?.notification_link
                              : "/notification"
                          }
                          className="d-block"
                          key={shortid.generate()}
                        >
                          <div className="row">
                            <div className="col-9">
                              <p>{value?.message}</p>
                            </div>
                            <div className="col-3">
                              <span>
                                {value?.is_read ? (
                                  <i className="fa-solid fa-envelope-open"></i>
                                ) : (
                                  ""
                                )}
                                {value?.is_read ? (
                                  ""
                                ) : (
                                  <i className="fa-solid fa-envelope"></i>
                                )}
                                {value?.notification_created_date}
                              </span>
                            </div>
                          </div>
                        </Link>
                      ))
                  ) : (
                    <div className="no-notification-data-style">
                      <p>No notification data available</p>
                    </div>
                  )}

                  {notificationData.notificationList?.length >= 3 ? (
                    <div className="multiple-btn">
                      <Link to="/notification" className="button">
                        See All Notification
                      </Link>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>

            <div
              className="user-img"
              id="user-header-img"
              onClick={(e) => open_profile_menu(e)}
            >
              <img
                src={
                  userData.userDetails?.profile_picture
                    ? userData.userDetails?.profile_picture
                    : avatar
                }
                alt=""
              />
            </div>
          </div>

          <MenuBar />
        </div>
      </div>
    </header>

    <Modal
          open={openLogoutModal}
          onClose={handleClose}
          aria-labelledby="modal-modal-title" 
          aria-describedby="modal-modal-description"
          className="logout-confirmation-modal"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
          <div className="modal-content" style={{
            backgroundColor: 'white',
            borderRadius: '8px',
            padding: '24px',
            maxWidth: '400px',
            width: '90%',
            position: 'relative'
          }}>
            <div className="modal-header">
              <h2 className="modal-title">Ready to Leave?</h2>
              <button className="close-button" 
                onClick={handleClose}
                style={{
                  position: 'absolute',
                  right: '16px',
                  top: '16px',
                  border: 'none',
                  background: 'none',
                  cursor: 'pointer'
                }}>
                <i className="fa-solid fa-times"></i>
              </button>
            </div>
            <div className="modal-body">
              <div className="icon-container">
                <div className="icon-circle" style={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '50%',
                  backgroundColor: '#f8f9fa',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '24px auto'
                }}>
                  <i className="fa-solid fa-sign-out-alt logout-icon" style={{fontSize: '32px', color: '#dc3545'}}></i>
                </div>
              </div>
              <p className="confirmation-message" style={{textAlign: 'center', fontSize: '18px', marginBottom: '12px'}}>
                We love to see you here! Are you sure you want to end your current session?
              </p>
              <p className="sub-message" style={{textAlign: 'center', color: '#6c757d', fontSize: '14px'}}>
                You'll need to log back in to access your account.
              </p>
            </div>
            <div className="modal-footer" style={{
              display: 'flex',
              justifyContent: 'center',
              gap: '16px',
              marginTop: '24px'
            }}>
              <button 
                className="btn-cancel"
                onClick={handleClose}
                style={{
                  padding: '8px 16px',
                  border: '1px solid #6c757d',
                  borderRadius: '4px',
                  backgroundColor: 'white',
                  color: '#6c757d',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}
              >
                <i className="fa-solid fa-arrow-left"></i>
                Stay Here
              </button>
              <button 
                className="btn-logout"
                onClick={handleLogout}
                style={{
                  padding: '8px 16px',
                  border: 'none',
                  borderRadius: '4px',
                  backgroundColor: '#dc3545',
                  color: 'white',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}
              >
                Yes, Log Out
                <i className="fa-solid fa-arrow-right"></i>
              </button>
            </div>
          </div>
    </Modal>
    </>
  );
};

export default React.memo(LoggedInUserHeader);
